(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sancho-tee-family"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sancho-tee-family')) {
  customElements.define('sancho-tee-family', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-family-handle]');
        if (!link || !this.contains(link)) return;
        const section = this.closest('.shopify-section') || document;
        const selected = section.querySelector('variant-picker input[data-option-name="Size"]:checked');
        const variants = JSON.parse(this.querySelector('[data-family-variants]').textContent);
        const size = selected?.value;
        const match = variants[link.dataset.familyHandle]?.find((variant) => variant.option1 === size);
        const url = new URL(link.href, window.location.origin);
        if (match) url.searchParams.set('variant', match.id);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        link.href = url.toString();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
